// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_ChaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /config/traducoes/chave and POST /config/traducoes/salvar. */
import type { Traducoes_ItemRow } from './Traducoes_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_ChaveResponseDados {
item: Traducoes_ItemRow
}

export type Traducoes_ChaveResponse = ApiResponse<Traducoes_ChaveResponseDados>;

registerResponseContract('Traducoes_ChaveResponse', {
  item: {
    type: 'object',
    required: false,
    fields: {
      pagina:    { type: 'string',  required: false },
      chave:     { type: 'string',  required: false },
      traducoes: { type: 'object',  required: false },
      faltantes: { type: 'array',   required: false },
    },
  },
})
